<template>
    <div id="app" v-if="!isIE">
        <nav class="navbar navbar-default navbar-fixed-top">
            <div class="container-fluid">
                <div class="navbar-header">
                    <a class="navbar-brand" href="#/">
                        <img v-bind:src="logotypeSrc" v-bind:alt="logotypeAlt" />
                    </a>
                </div>

                <ul class="nav navbar-nav">
                    <li>
                        <router-link to="/dashboard">
                            <span class="fa fa-home"></span>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/projects" v-if="isCustomerAdmin">Projekt</router-link>
                    </li>                              
                    <li class="dropdown" v-if="isCustomerAdmin">
                        <a href="#"
                           class="dropdown-toggle"
                           id="ddResources"
                           data-toggle="dropdown"
                           role="button"
                           aria-haspopup="true"
                           aria-expanded="false">
                            Resurser
                            <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="ddResources">
                            <li>
                                <router-link to="/onlocation">På plats</router-link>
                            </li>
                            <li>
                                <router-link to="/resourcesoverview">Översikt</router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="!isSubcontractor && !isCallcenter">
                        <router-link to="/week">Mina tider</router-link>
                    </li>
                    <li>
                        <router-link to="/reports">Rapporter</router-link>
                    </li>
                    <li class="dropdown" v-if="!isCallcenter">
                        <a href="#"
                           class="dropdown-toggle"
                           id="ddCreate"
                           data-toggle="dropdown"
                           role="button"
                           aria-haspopup="true"
                           aria-expanded="false">
                            Nytt
                            <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="ddCreate">
                            <li v-if="appModal == 1">
                                <router-link to="/request">Begära ärende</router-link>
                            </li>
                            <li v-if="appModal == 1" role="separator" class="divider"></li>
                            <li>
                                <router-link :to="{ name: 'create-new-errand-custom'}">Skapa ärende</router-link>
                            </li>                           
                        </ul>
                    </li>
                    <li class="dropdown" v-if="isCustomerAdmin">
                        <a href="#"
                           class="dropdown-toggle"
                           id="ddHandle"
                           data-toggle="dropdown"
                           role="button"
                           aria-haspopup="true"
                           aria-expanded="false">
                            Hantera
                            <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="ddHandle">
                            <li>
                                <router-link to="/projects">Projekt</router-link>
                            </li>
                            <li>
                                <router-link to="/invoicesummary">Sammanställningar</router-link>
                            </li>
                            <li>
                                <router-link to="/customers">Kunder</router-link>
                            </li>
                            <li>
                                <router-link to="/ResourceGroups">Resursgrupper</router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="dropdown" v-if="isCustomerAdmin && appModal == 1">
                        <a href="#"
                           class="dropdown-toggle"
                           id="ddSla"
                           data-toggle="dropdown"
                           role="button"
                           aria-haspopup="true"
                           aria-expanded="false">
                            SLA
                            <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="ddSla">
                            <li>
                                <router-link to="/classic/sla">Översikt</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/sla-cs">CS Rapportering</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/sla-rnuh">RNUH Rapportering</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/sla-lnuh">LNUH Rapportering</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/sla-no">NO Rapportering</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/sla-uh">UH Rapportering</router-link>
                            </li>
                        </ul>
                    </li>

                    <li v-if="isAdmin" class="dropdown">
                        <a href="#"
                           class="dropdown-toggle"
                           id="ddAdmin"
                           data-toggle="dropdown"
                           role="button"
                           aria-haspopup="true"
                           aria-expanded="false">
                            Admin
                            <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="ddAdmin">
                            <li>
                                <router-link to="/task-types">Tjänstetyper</router-link>
                            </li>
                            <li>
                                <router-link to="/root-register">Grundregister</router-link>
                            </li>
                            <li>
                                <router-link to="/documents">Mappar</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/public-holidays">SLA - Icke arbetsdagar</router-link>
                            </li>
                            <li>
                                <router-link to="/admin/reports">Rapporter</router-link>
                            </li>
                            <li>
                                <router-link to="/admin/public-holidays">Röda dagar</router-link>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                                <router-link to="/codex-queue">Codex kö</router-link>
                            </li>
                            <li v-if="appModal == 1">
                                <router-link to="/message-queue">Ellevio kö</router-link>
                            </li>
                            <li v-if="appModal == 1">
                                <router-link to="/classic/messagelog-error">Ellevio nacklista</router-link>
                            </li>
                            <li v-if="appModal == 2">
                                <router-link to="/message-queue-2">EON Kö</router-link>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                                <router-link to="/alerts">Meddelande</router-link>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                                <router-link to="/admin/user-customers">Användare</router-link>
                            </li>
                            <li>
                                <router-link to="/admin/resources">Resurser</router-link>
                            </li>
                            <li role="separator" class="divider"></li>

                            <li>
                                <router-link to="/articles">Artiklar</router-link>
                            </li>
                            <li>
                                <router-link to="/admin/articles">Artiklar (indexera)</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'article-favorites' }">Favoriter</router-link>
                            </li>
                            <li>
                                <router-link to="/pricelists">Avtalsprislista</router-link>
                            </li>
                            <li>
                                <router-link to="/classic/pricelistimport">Avtalsprislista import</router-link>
                            </li>

                            <li>
                                <router-link to="/classic/articlesimport">Importera från Ahlsell</router-link>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                                <router-link to="/classic/errand_admin">Ärende tvinga status</router-link>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                                <router-link to="/dashboard-edit">Startsida (Dashboard)</router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-if="!resourceId">
                        <a class="text-danger" style="color: #f00">Inloggad användare saknar resurs!</a>
                    </li>
                </ul>

                <div class="navbar-form navbar-right" role="search">
                    <div class="input-group">
                        <RecentErrands class="input-group-btn" @set-errand="setModalEntry" />
                        <input v-model="errandNo"
                               class="form-control"
                               v-bind:placeholder="searchPlaceholder"
                               v-bind:class="{ 'placeholder-red': showSearchWarning }"
                               v-on:keyup.enter="searchErrandType1" />
                        <div class="input-group-btn">
                            <button class="btn btn-default"
                                    type="button"
                                    @click="searchErrandType1">
                                Omexom
                            </button>
                            <button class="btn btn-default"
                                    type="button"
                                    @click="searchErrandType2">
                                {{ button2Name }}
                            </button>
                        </div>
                    </div>
                    <VDropdown :trigger="'click'"
                               :autoHide="true"
                               :open="showUserInfo"
                               style="display: inline-block">
                        <div class="btn btn-link" @click.prevent="showUserInfo = true">
                            <span class="glyphicon glyphicon-user"></span>
                        </div>
                        <template #popper>
                            <div class="userInfo">
                                <ul class="list-unstyled">
                                    <li>
                                        <strong>{{ userFullName }}</strong>
                                    </li>
                                    <li>
                                        {{ userName }}
                                    </li>
                                    <li><hr /></li>
                                    <li><a :href="logoutUrl">Logga ut</a></li>
                                </ul>
                            </div>
                        </template>
                    </VDropdown>
                </div>
            </div>
        </nav>
        <CustomAlerts />
        <router-view />
        <ErrandModal v-if="showModal"
                     :modalEntry="modalEntry"
                     @set-modal-entry="modalEntry = $event"
                     @close-modal="
    showModal = false;
    modalEntry = null;
  " />

        <ConfirmModal />
        <portal-target name="modals" />
    </div>
  <div v-else class="container">
    <div class="alert alert-danger">
      <h1 style="margin: 0">Denna applikation stödjs inte i IE</h1>
      <p>Rekommenderat är Chrome, Firefox, eller Edge</p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
// mixins
import ModalMixin from "@/mixins/ModalMixin";
import ConfirmModal from "@/components/Modals/ConfirmModal";
import CustomAlerts from "@/components/CustomAlerts";
import RecentErrands from "@/components/RecentErrands";

export default {
  name: "App",
  mixins: [ModalMixin],
  components: { ConfirmModal, CustomAlerts, RecentErrands },
  data: function () {
    return {
      logotypeSrc: process.env.VUE_APP_URL_LOGO,
      logotypeAlt: process.env.VUE_APP_TITLE,
      button2Name: process.env.VUE_APP_TITLE,
      appModal: process.env.VUE_APP_MODAL,
      logoutUrl: process.env.VUE_APP_ROOT_URL + "/logout.aspx",
      errandNo: "",
      showSearchWarning: false,
      showModal: false,
      showUserInfo: false,
      modalEntry: null,
        searchPlaceholder: "Öppna ärendenr...",
        currentModalEntry: null
    };
  },
  mounted() {
    this.getCurrentUser();
  },
  computed: {
    ...mapState({
      isCustomerAdmin: (state) => state.user.isCustomerAdmin,
      isAdmin: (state) => state.user.isAdmin,
      isSubcontractor: (state) => state.user.isSubcontractor,
      isCallcenter: (state) => state.user.isCallcenter,
      resourceId: (state) => state.user.resourceId,
      userFullName: (state) => state.user.userFullName,
      userName: (state) => state.user.userName,
    }),
    isIE() {
      var ua = window.navigator.userAgent;
      if (ua.indexOf("MSIE ") > 0 || ua.indexOf("Trident/") > 0)
        // If Internet Explorer, return version number
        return true;
      return false;
    },
  },
  methods: {
    ...mapActions("user/", ["getCurrentUser"]),
    searchErrandType1() {
      this.searchErrand(this.errandNo, 1);
    },
    searchErrandType2() {
      this.searchErrand(this.errandNo, 2);
    },
    searchErrand(searchString, searchType) {
      this.searchPlaceholder = "Sök ärendenr...";
      this.errandNo = "";
      this.showSearchWarning = false;
      if (searchString != "") {
        axios
          .get(
            process.env.VUE_APP_ROOT_API +
              `Errand/Search?searchType=${searchType}&searchString=${searchString}`,
            { withCredentials: true }
          )
          .then((response) => {
            if (response.data > 0) {
              this.modalEntry = response.data;
              this.showModal = true;
            } else {
              this.searchPlaceholder = "Hittade inget ärende...";
              this.showSearchWarning = true;
            }
          })
          .catch((e) => {
            this.errors.push(e);
            this.showSearchWarning = true;
            this.searchPlaceholder = "Hittade inget ärende...";
          });
      }
      },
      setModalEntry(errandId) {
          this.modalEntry = errandId;
          this.showModal = true;
      },


  },
};
</script>
<style>

.fa {
  font-size: 16px;
}
@media (max-width: 768px) {
  #app {
    margin-top: 70px;
  }
}
blockquote {
  padding: 0 0 0 10px !important;
  margin: 3px 0 15px 0 !important;
}
.navbar-default {
  background-color: #ffffff !important;
  border-bottom: solid 4px #18c2df !important;
}



body {
  padding-top: 70px;
}

@media (max-width: 1350px) {
    body {
        padding-top: 120px;
    }
}


.multiselect {
  z-index: 3;
}
.multiselect__content-wrapper {
  z-index: 9999 !important;
}
.multiselect__content,
.multiselect__content {
  z-index: 9999 !important;
}
.btn-group-vertical > .btn.active,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:hover,
.btn-group > .btn.active,
.btn-group > .btn:active,
.btn-group > .btn:focus,
.btn-group > .btn:hover {
  z-index: 0;
}
.input-group .form-control {
  z-index: 1;
}
.form-control.placeholder-red::-webkit-input-placeholder {
  color: red !important;
} /* WebKit, Blink, Edge */
.form-control.placeholder-red:-moz-placeholder {
  color: red !important;
} /* Mozilla Firefox 4 to 18 */
.form-control.placeholder-red::-moz-placeholder {
  color: red !important;
} /* Mozilla Firefox 19+ */
.form-control.placeholder-red:-ms-input-placeholder {
  color: red !important;
} /* Internet Explorer 10-11 */
.form-control.placeholder-red::-ms-input-placeholder {
  color: red !important;
} /* Microsoft Edge */
.btn-default:hover,
.btn-default:focus,
.btn-default:active:focus {
  background-color: #027a99;
}
/* SLA labels */
.label-blue {
  background-color: #2196f3;
}
.label-orange {
  background-color: #ff9f1a;
}
.userInfo {
  text-align: left;
  margin: 10px;
}

.mt-0{
    margin-top: 0;
}
</style>
